import { Link } from 'react-router-dom';
import { cn } from '../../utility/base';
import { buttonVariants } from '@playcastdotio/Shadcn';
import config from '../../config.json';
import { useEffect } from 'react';

export const Discord = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  });

  return (
    <div className='w-full h-auto m-0 p-0 bg-content text-content-text'>
      <div className='w-full h-auto m-0 p-0 bg-hero bg-cover bg-no-repeat bg-content text-content-text'>
        <div className='container mx-auto w-full h-auto pt-20 pb-8 px-8'>
          <section id='hero' className='grid grid-cols-12 gap-y-8 gap-x-4'>
            <div className='col-span-full md:col-span-6 grid grid-rows content-center gap-y-4 lg:gap-y-8'>
              <h1 className='row-auto font-bold text-3xl lg:text-4xl'>Join the Community!</h1>
              <p className='row-auto'>
                Join the growing group of Playcasters on Discord to chat with our team and other streamers and report bugs you find so we
                can fix them as soon as possible. If you’re interested in becoming a UX Tester you can the dedicated channel on Discord and
                help shape the future of Playcast!
              </p>
              <Link to={config.DISCORD_URL} className={cn(buttonVariants(), 'rounded-full w-fit')}>
                Join The Discord
              </Link>
            </div>

            <div className='col-span-full md:col-span-5 md:col-start-8 content-center'>
              <img src='/images/preview-image.png' alt='screenshot' />
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};
